<template>
  <DefaultLayout>
    <div>
      <div class="container" row row-grid align-items-center>
        {{ introText }}
      </div>
      <div>
        <br />
        <div class="text-center">
          <base-button type="success" v-on:click="start()">{{ $t('start') }}</base-button>
        </div>
        <br />
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import Vue from "vue";
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  components: { DefaultLayout },
  data: function () {
    return {};
  },
  async created() {
    // Let's check whether intro text exists for this scenario:
    let count = 0;

    for (let i = 0; i < this.$store.state.main.scenarios.length; i++) {
      if (this.$store.getters.getIsFacilitator) {
        if (this.$store.state.main.scenarios[i].intro_text_facilitator) {
          count++;
        }
      } else if (this.$store.state.main.scenarios[i].intro_text_player) {
        count++;
      }
    }

    if (count === 0) {
      // Nope, let's go on

      this.$store.dispatch("log", "No intro text exists for this scenario.");

      await this.$router.push("/welcome");
    } else {
      this.$store.dispatch("connectNotification");
    }
  },
  computed: {
    introText() {
      const scenario = this.$store.getters.getScenarioInCurrentLocale;

      if (this.$store.getters.getIsFacilitator) {
        return scenario.intro_text_facilitator;
      } else {
        return scenario.intro_text_player;
      }
    },
  },
  methods: {
    async start() {
      await this.$router.push("/welcome");
    },
  },
};
</script>

<i18n>
{
  "en": {
    "start": "Let's go!"
  },
  "fi": {
    "start": "Aloitetaan!"
  },
 "sv": {
    "start": "Då börjar vi!"
  },
 "de": {
    "start": "Los geht's!"
  },
 "ko": {
    "start": "시작하기"
  }
}
</i18n>
